/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} So_Status_Released_To_3plInputs */

const en_so_status_released_to_3pl = /** @type {(inputs: So_Status_Released_To_3plInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Released to the warehouse`)
};

/**
* | output |
* | --- |
* | "Released to the warehouse" |
*
* @param {So_Status_Released_To_3plInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const so_status_released_to_3pl = /** @type {((inputs?: So_Status_Released_To_3plInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<So_Status_Released_To_3plInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_so_status_released_to_3pl(inputs)
});